import { useState } from "react"
import { partial } from "../oneliners"
import en from '../translation/en.json'
import rw from '../translation/rw.json'

const languages = { en, rw }

const translate = (language, key) => {
    return languages[language][key] || key
}

const useTranslator = (current) => {
    const [curLang,] = useState(current || Object.keys(languages)[0])
    const availableLanguages = Object.keys(languages)
    const changeLanguage = (newLang) =>{
        let prev = curLang
        window.localStorage.HBFLanguage = newLang
        window.location.pathname = window.location.pathname.slice(prev.length+1) 
    }
    return [curLang, changeLanguage, availableLanguages, partial(translate, curLang)]
}

export { useTranslator }